// import { MDBInput } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'

export default function AssignSeats({ register, watch, errors, setValue, getValues, assignseats }) {
    const [serviceIdList, setserviceIdList] = useState([]);
    const [servicePlanList, setservicePlanList] = useState([]);
    const [serviceObj, setserviceObj] = useState({});


    console.log(typeof (assignseats));
    console.log("value for seats are  ::::::::::::::::;; " + JSON.stringify(assignseats));

    useEffect(() => {
        if (assignseats && assignseats.length > 0) {
            const updatedValue = assignseats.map((assign) => ({ ...assign, available_seats: Array.from({ length: assign?.available_seats }, (_, i) => i + 1) }));
            // console.log("updatedValue ::::::::::::: " +JSON.stringify(updatedValue));
            setservicePlanList(updatedValue);
            setserviceObj({});
            setserviceIdList([]);
        }
    }, [assignseats]);
    console.log(serviceObj)
    const handleAssignSeat = (e, serviceid) => {
        e.preventDefault();
        const value = parseInt(serviceid);
        const no_ofSeat = e.target.value;
        let SeatsList = watch("assign_seats");
        if (no_ofSeat !== -1) {
            if (!serviceIdList.includes(value)) {
                let updatedValue = [...serviceIdList, value];

                setserviceIdList(updatedValue);
            }
            delete serviceObj[serviceid];
            let updatedObj = { ...serviceObj, [serviceid]: parseInt(no_ofSeat) }
            setserviceObj(updatedObj);
            console.log("service obj::::::::" + JSON.stringify(updatedObj))
            SeatsList = SeatsList.filter((seat) => seat.service_id !== serviceid);
            const newValue = {
                service_id: parseInt(value),
                no_of_seats: parseInt(no_ofSeat)
            }
            SeatsList = [...SeatsList, newValue]

        } else {
            let updatedvalue = serviceIdList.filter((service) => service !== serviceid);
            delete serviceObj[serviceid];
            setserviceIdList(updatedvalue);
            SeatsList = SeatsList.filter((seat) => seat.service_id !== serviceid);
        }

        console.log("SeatsList :::::::::::::::::::::::::::::::::; " + JSON.stringify(SeatsList));

        setValue(`assign_seats`, SeatsList, { shouldDirty: true });

    };

    return (
        <div>

            <div className="general-settings" id="general">
                Assign Seats
            </div>

            {servicePlanList.map((seat, index) => (
                <div className="add-numbermain">
                    <div className="tel-numbers"  >{seat?.service_name}  </div>
                    <div className="d-flex w-30">
                        <div className="phoneselect w-100">
                            <select id=""
                                name=""
                                className="form-control form-select"
                                value={(serviceIdList.includes(seat.serviceid) ? serviceObj[seat.serviceid] : -1)}
                                onChange={(e) =>
                                    handleAssignSeat(e, seat.serviceid)}>

                                <option value={-1}>--Selected Seat(S)--</option>
                                {seat?.available_seats?.map((num) => (
                                    <option value={parseInt(num)}>{num} </option>

                                ))}

                                {/* {Array.from({ length: seat?.no_of_seats }, (_, i) => i + 1).map((num) => (
                                    <option key={num} value={num}>
                                        {num}
                                    </option>
                                ))} */}

                            </select>

                        </div>
                    </div>
                </div>
            ))}
            {/* 
             <div className="add-numbermain">
                <div className="tel-numbers"> {watch("assign_seats[1].service_name")}</div>
                <div className="d-flex w-30">
                    <div className="phoneselect w-100">


                        <select name="" id="" className="form-control form-select"
                            value={watch("assign_seats[1].no_of_seats")}
                            onChange={(e) => {
                                setValue("assign_seats[1].no_of_seats", (e.target.value), {
                                    shouldDirty: true,
                                });
                            }}
                            >
                            <option selected>--Selected Seat(S)--</option>
                            {Array.from({ length: assign_seats[1].no_of_seats }, (_, idx) => idx + 1).map((val) => (
                                <option key={val} value={val}>
                                    {val}
                                </option>
                            ))}
                           

                        </select>


                    </div>
                </div>
            </div>  */}


        </div>

    )
}

